import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function TrainerHowItWorks() {
	const { t } = useTranslation();
	const primaryColor = "#43bd98";
	const accent = "#4A90E2";

	const steps = t("trainer.how.steps", { returnObjects: true });

	const containerVariants = {
		hidden: {},
		show: { transition: { staggerChildren: 0.15 } },
	};

	const cardVariants = {
		hidden: { opacity: 0, y: 25, scale: 0.98, filter: "blur(6px)" },
		show: {
			opacity: 1,
			y: 0,
			scale: 1,
			filter: "blur(0px)",
			transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] },
		},
	};

	return (
		<section
			style={{
				padding: "6rem 2rem",
				backgroundColor: "#ffffff",
				fontFamily: "'Poppins', sans-serif",
			}}
		>
			{/* Título */}
			<motion.div
				style={{ textAlign: "center", marginBottom: "3rem" }}
				initial={{ opacity: 0, y: 20 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.7, ease: "easeOut" }}
				viewport={{ once: true, amount: 0.3 }}
			>
				<p
					style={{
						color: accent,
						fontSize: "0.9rem",
						fontWeight: 600,
						letterSpacing: "1px",
						textTransform: "uppercase",
						marginBottom: "0.5rem",
					}}
				>
					{t("trainer.how.badge")}
				</p>
				<h2
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						color: "#1a1a1a",
						fontWeight: 800,
						margin: 0,
					}}
				>
					{t("trainer.how.title")}
				</h2>
			</motion.div>

			{/* Steps */}
			<motion.div
				variants={containerVariants}
				initial="hidden"
				whileInView="show"
				viewport={{ once: true, amount: 0.3 }}
				style={{
					display: "flex",
					flexWrap: "wrap",
					justifyContent: "center",
					gap: "2rem",
				}}
			>
				{steps.map((step, index) => (
					<motion.div
						key={index}
						variants={cardVariants}
						whileHover={{
							y: -6,
							scale: 1.02,
							boxShadow: "0 10px 25px rgba(67,189,152,0.15)",
							transition: { duration: 0.25 },
						}}
						className="step-card"
						style={{
							flex: "1 1 240px",
							maxWidth: "260px",
							backgroundColor: "#f8fefc",
							border: `1px solid ${primaryColor}`,
							borderRadius: "18px",
							padding: "2.4rem 1.8rem",
							textAlign: "center",
							boxShadow: "0 8px 24px rgba(0,0,0,0.03)",
							transition: "all 0.3s ease",
						}}
					>
						<div
							style={{
								width: "56px",
								height: "56px",
								borderRadius: "50%",
								backgroundColor: primaryColor,
								color: "#fff",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontWeight: 700,
								fontSize: "1.2rem",
								margin: "0 auto 1.2rem auto",
								boxShadow: "0 4px 12px rgba(67,189,152,0.3)",
							}}
						>
							{index + 1}
						</div>
						<h3
							style={{
								fontSize: "1.1rem",
								fontWeight: 600,
								color: "#222",
								marginBottom: "0.6rem",
							}}
						>
							{step.title}
						</h3>
						<p
							style={{
								color: "#555",
								fontSize: "0.95rem",
								lineHeight: 1.6,
							}}
						>
							{step.description}
						</p>
					</motion.div>
				))}
			</motion.div>

			<style>{`
				@media (max-width: 640px) {
					.step-card {
						flex: 1 1 auto !important;
						max-width: 100% !important;
						width: auto !important;
					}
				}
			`}</style>
		</section>
	);
}
